import { useState } from "react";
import { fetcher } from "../../../../services/fetcher";
import { Stack } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import {
  errorNotifications,
  successNotifications,
} from "../../../../utils/handleNotifications";
import nationalities from "../../../../data/nationality.json";
import countries from "../../../../data/countries.json";
import useCoverOptions from "../../../../common/hooks/useCoverOptions/useCoverOptions";
import CustomizeForm from "../../forms/CustomizeCoverForm/CustomizeCoverForm";
import useAdventureOptions from "../../../../common/hooks/useAdventureOptions/useAdventureOptions";
import useOtherOptions from "../../../../common/hooks/useOtherOptions/useOtherOptions";
import useFaqsOptions from "../../../../common/hooks/useFaqsOptions/useFaqsOptions";
import dayjs from "dayjs";
import PlanFormPageShell from "../../components/PlanFormPageShell/PlanFormPageShell";
// import classes from "./AddCustomizeCover.module.css";

const AddCustomizeCover = ({ mode }) => {
  const endpoint = "cover-api/customize-covers/";

  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { options: adventureOptions, isLoading } = useAdventureOptions(
    "cover-api/adventures/"
  );

  const { options: partnersOptions, isLoading: loadingPartners } =
    useOtherOptions("cover-api/insurance-partners/");

  const { options: coverOptions, isLoading: loadingCovers } = useCoverOptions(
    "cover-api/master-covers/"
  );

  const { options: faqsOptions, isLoading: loadingFqas } = useFaqsOptions(
    "faq/faqs/"
  );

  const addCustomizeCoverMutation = async (newCover) => {
    setIsSubmitting(true);
    try {
      await fetcher(endpoint, "POST", newCover, {
        "content-type": "multipart/form-data",
      });

      navigate(-1);
      successNotifications("Success! Customize covers added");
    } catch (error) {
      console.error(error);
      errorNotifications(error.response.data, error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (payload) => {
    const formData = new FormData();

    for (const key in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        if (Array.isArray(payload[key])) {
          payload[key].forEach((id) => {
            formData.append(key, id);
          });
        } else {
          if (key === "start_date" || key === "end_date") {
            const formattedDate = dayjs(payload[key]).format("YYYY-MM-DD");
            formData.append(key, formattedDate);
          } else {
            formData.append(key, payload[key]);
          }
        }
      }
    }

    addCustomizeCoverMutation(formData);
  };

  return (
    <>
      <PlanFormPageShell title="+ Add Customized Plan">
        <Stack mt="xl">
          <CustomizeForm
            mode={mode}
            masterCovers={loadingCovers ? [] : coverOptions}
            nationalities={nationalities}
            countries={countries}
            adventureOptions={isLoading ? [] : adventureOptions}
            partnersOptions={loadingPartners ? [] : partnersOptions}
            faqsOptions={loadingFqas ? [] : faqsOptions}
            isSubmitting={isSubmitting}
            onSubmit={handleSubmit}
          />
        </Stack>
      </PlanFormPageShell>
    </>
  );
};

export default AddCustomizeCover;
